import { gql } from '@apollo/client';

const MY_CLIENTS = gql`
  query myClients($id_In: [String]) {
    getMasterEntities(id_In: $id_In) {
    totalCount
      edges {
        cursor
        node {
            id
            name
            invoicesActualPaymentTerm
            displayNationalIdentifier
            clientOffers @client
        }
      }
    }
  }
`;

export default MY_CLIENTS;
